//#region src/TableAg/TablePagination.lib.ts
const DEFAULT_TABLE_PAGE_SIZES = [
	5,
	10,
	20,
	50,
	100
];
const toUiPage = (gridPageIndex) => gridPageIndex + 1;
const toGridPage = (uiPage) => Math.max(0, uiPage - 1);
const isServerSidePagination = (pagination, rowModelType) => pagination && rowModelType === "serverSide";
/**
* Один блок = текущая страница, предыдущая вытесняется — getRows на каждый переход.
* `maxBlocksInCache` задаётся только при создании грида (не managed option).
*/
const getServerSidePaginationGridOptions = (pageSize) => ({
	cacheBlockSize: pageSize,
	maxBlocksInCache: 1
});
const resolvePageSizeSelector = (selector) => {
	if (selector === false) return null;
	if (Array.isArray(selector)) return selector.length > 0 ? selector : null;
	return [...DEFAULT_TABLE_PAGE_SIZES];
};
//#endregion
export { DEFAULT_TABLE_PAGE_SIZES, getServerSidePaginationGridOptions, isServerSidePagination, resolvePageSizeSelector, toGridPage, toUiPage };

//# sourceMappingURL=TablePagination.lib.js.map